function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Text from "./Text";
export const DisplayTextProps = {
  size: 32,
  lineHeight: 40,
  weight: 'regular'
};
export const Display = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "dark"
}, props, DisplayTextProps));
export const HeadlineTextProps = {
  size: 24,
  lineHeight: 32,
  weight: 'regular'
};
export const Headline = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "dark"
}, props, HeadlineTextProps));
export const IntroTextProps = {
  size: 16,
  lineHeight: 24,
  weight: 'regular'
};
export const Intro = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, IntroTextProps));
export const TitleTextProps = {
  size: 20,
  lineHeight: 28,
  weight: 'regular'
};
export const Title = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "dark"
}, props, TitleTextProps));
export const HeadingTextProps = {
  size: 16,
  lineHeight: 24,
  weight: 'medium'
};
export const Heading = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "dark"
}, props, HeadingTextProps));
export const SubheadingTextProps = {
  size: 13,
  lineHeight: 20,
  weight: 'medium',
  typeface: 'upper'
};
export const Subheading = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "dark"
}, props, SubheadingTextProps));
export const BodyTextProps = {
  size: 14,
  lineHeight: 20,
  weight: 'regular'
};
export const Body = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, BodyTextProps));
export const BodyAltTextProps = {
  size: 14,
  lineHeight: 20,
  weight: 'medium'
};
export const BodyAlt = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, BodyAltTextProps));
export const BodyExtraTextProps = {
  size: 14,
  lineHeight: 20,
  weight: 'bold'
};
export const BodyExtra = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, BodyExtraTextProps));
export const BodyMonoTextProps = {
  size: 13,
  lineHeight: 20,
  weight: 'regular',
  typeface: 'mono'
};
export const BodyMono = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, BodyMonoTextProps));
export const BodyAltMonoTextProps = {
  size: 13,
  lineHeight: 20,
  weight: 'bold',
  typeface: 'mono'
};
export const BodyAltMono = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, BodyAltMonoTextProps));
export const CaptionTextProps = {
  size: 12,
  lineHeight: 16,
  weight: 'regular'
};
export const Caption = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, CaptionTextProps));
export const CaptionAltTextProps = {
  size: 12,
  lineHeight: 16,
  weight: 'medium'
};
export const CaptionAlt = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, CaptionAltTextProps));
export const CaptionCapsTextProps = {
  size: 12,
  lineHeight: 16,
  weight: 'medium',
  typeface: 'upper'
};
export const CaptionCaps = props => /*#__PURE__*/React.createElement(Text, _extends({
  color: "gray"
}, props, CaptionCapsTextProps));
export const CaptionExtraTextProps = {
  size: 12,
  lineHeight: 16,
  weight: 'bold'
};
export const CaptionExtra = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, CaptionExtraTextProps));
export const CaptionMonoTextProps = {
  size: 11,
  lineHeight: 16,
  weight: 'regular',
  typeface: 'mono'
};
export const CaptionMono = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, CaptionMonoTextProps));
export const CaptionAltMonoTextProps = {
  size: 11,
  lineHeight: 16,
  weight: 'bold',
  typeface: 'mono'
};
export const CaptionAltMono = props => /*#__PURE__*/React.createElement(Text, _extends({}, props, CaptionAltMonoTextProps));